import React, { Fragment, Component } from "react";
import Breadcrumb from "../../common/breadcrumb";
import CountUp from "react-countup";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
import { Users, Folder, Layers, Globe, Book, Package, Calendar, Bookmark, Briefcase, UserPlus, UserCheck, Activity } from "react-feather";
import { callAllKpis } from "../../../Graphs/Dashboard/callKpis";
import { withRouter } from "react-router";
import { connect } from "react-redux";
import { Link } from "react-router-dom";
import { checkPermission } from "../../AdminUser/CheckPremission";
import {
  ACCESS_DENIED_MESSAGE,
  ACCESS_DENIED_MESSAGE_DESCRIPTION,
} from "../../../constant/comman";
import { notification } from "antd";

class Default extends Component {
  constructor(props) {
    super(props);
    this.state = {
      userCount: 0,
      categoryCount: 0,
      subCategoryCount: 0,
      languageCount: 0,
      courseCount: 0,
      sessionCount: 0,
      topicCount: 0,
      moduleCount: 0,
      departmentsCount: 0,
      totalMaxUsers: 0,
      totalAssignCount: 0,
      availableSeats: 0,
      primaryColor: "#4466f2",
      isLoading: false,
    };
  }

  async componentDidMount() {
    //check the logged-in user has the module view permission else it will redirect to the defined route start
    if (
      !checkPermission(
        this.props.loginUserData.permissions,
        "dashboard",
        "view"
      )
    ) {
      notification["error"]({
        message: ACCESS_DENIED_MESSAGE,
        description: ACCESS_DENIED_MESSAGE_DESCRIPTION,
      });
      this.props.history.replace("/edit-profile");
    }
    //check the logged-in user has the module view permission else it will redirect to the defined route end

    try {
      const {
        authToken,
        history,
        setLoginFlag,
        setUserData,
        setUserToken,
        setRouteName,
      } = this.props;
      let primaryColor = await localStorage.getItem("primary_color") || "#4466f2";
      this.setState({
        primaryColor,
        isLoading: true,
      });

      await setRouteName("DASHBOARD");
      let responseKpiData = await callAllKpis(authToken);
      console.log(responseKpiData.data);
      if (responseKpiData.status === 200) {
        //set kpi data
        this.setState({
          userCount: responseKpiData.data.userCount,
          categoryCount: responseKpiData.data.categoryCount,
          subCategoryCount: responseKpiData.data.subCategoryCount,
          languageCount: responseKpiData.data.languageCount,
          courseCount: responseKpiData.data.courseCount,
          sessionCount: responseKpiData.data.sessionCount,
          topicCount: responseKpiData.data.topicCount,
          moduleCount: responseKpiData.data.moduleCount,
          departmentsCount: responseKpiData.data.departmentsCount,
          totalMaxUsers: responseKpiData.data.totalMaxUsers || 0,
          totalAssignCount: responseKpiData.data.totalAssignCount || 0,
          availableSeats: responseKpiData.data.availableSeats || 0,
        });
      } else if (responseKpiData.status === 401) {
        await setLoginFlag(false);
        await setUserData(null);
        await setUserToken(null);
        history.push(`${process.env.PUBLIC_URL}/login`);
      }
    } catch (e) {
      console.log("!!!!!!!!error in did mount", e);
    } finally {
      this.setState({
        isLoading: false,
      });
    }
  }

  render() {
    const {
      userCount,
      categoryCount,
      subCategoryCount,
      languageCount,
      courseCount,
      sessionCount,
      topicCount,
      moduleCount,
      departmentsCount,
      totalMaxUsers,
      totalAssignCount,
      availableSeats,
      primaryColor,
    } = this.state;

    const { loginUserData } = this.props;
    console.log(loginUserData.role);

    const hexToRgba = (hex, alpha) => {
      if (!hex) return `rgba(68, 102, 242, ${alpha})`;
      const r = parseInt(hex.slice(1, 3), 16);
      const g = parseInt(hex.slice(3, 5), 16);
      const b = parseInt(hex.slice(5, 7), 16);
      return `rgba(${r}, ${g}, ${b}, ${alpha})`;
    };

    const css = `
      .dashboard-card {
        background: ${primaryColor};
        border-radius: 12px;
        padding: 24px 20px;
        color: #ffffff !important;
        box-shadow: 0 4px 15px ${hexToRgba(primaryColor, 0.15)};
        display: flex;
        align-items: center;
        justify-content: space-between;
        position: relative;
        overflow: hidden;
        transition: all 0.3s cubic-bezier(0.25, 0.8, 0.25, 1);
        min-height: 116px;
      }
      .dashboard-card.clickable {
        cursor: pointer;
      }
      .dashboard-card.clickable:hover {
        transform: translateY(-6px);
        box-shadow: 0 12px 24px ${hexToRgba(primaryColor, 0.3)};
      }
      .dashboard-card .card-label {
        font-size: 14px;
        font-weight: 500;
        color: rgba(255, 255, 255, 0.8) !important;
        margin: 0;
      }
      .dashboard-card .card-count {
        font-size: 28px;
        font-weight: 700;
        margin-top: 4px;
        color: #ffffff !important;
      }
      .dashboard-card .card-icon {
        color: #ffffff;
        opacity: 0.15;
        position: absolute;
        right: -10px;
        bottom: -10px;
        width: 80px;
        height: 80px;
        transition: all 0.3s ease;
      }
      .dashboard-card.clickable:hover .card-icon {
        opacity: 0.35;
        transform: scale(1.15) rotate(-10deg);
      }
    `;

    return (
      <Fragment>
        <style>{css}</style>
        <Breadcrumb parent="Dashboard" title="Dashboard" />
        <div className="container-fluid" style={{ padding: "10px 14px 20px 14px" }}>
          <div style={{
            display: "grid",
            gridTemplateColumns: "repeat(auto-fit, minmax(240px, 1fr))",
            gap: "20px",
            width: "100%"
          }}>
            {/* Total Users */}
            <div
              className="dashboard-card clickable"
              onClick={() => this.props.history.push(`${process.env.PUBLIC_URL}/user`)}
            >
              <div>
                <div className="card-label">Total Users</div>
                <div className="card-count">
                  <CountUp className="counter" end={userCount} />
                </div>
              </div>
              <Users className="card-icon" />
            </div>

            {/* Total Categories */}
            {loginUserData && loginUserData.role !== "corporate" && (
              <div
                className="dashboard-card clickable"
                onClick={() => this.props.history.push(`${process.env.PUBLIC_URL}/category`)}
              >
                <div>
                  <div className="card-label">Total Categories</div>
                  <div className="card-count">
                    <CountUp className="counter" end={categoryCount} />
                  </div>
                </div>
                <Folder className="card-icon" />
              </div>
            )}

            {/* Total Sub Categories */}
            {loginUserData && loginUserData.role !== "corporate" && (
              <div
                className="dashboard-card clickable"
                onClick={() => this.props.history.push(`${process.env.PUBLIC_URL}/sub-category`)}
              >
                <div>
                  <div className="card-label">Total Sub Categories</div>
                  <div className="card-count">
                    <CountUp className="counter" end={subCategoryCount} />
                  </div>
                </div>
                <Layers className="card-icon" />
              </div>
            )}

            {/* Total Languages */}
            {loginUserData && loginUserData.role !== "corporate" && (
              <div
                className="dashboard-card clickable"
                onClick={() => this.props.history.push(`${process.env.PUBLIC_URL}/language`)}
              >
                <div>
                  <div className="card-label">Total Languages</div>
                  <div className="card-count">
                    <CountUp className="counter" end={languageCount} />
                  </div>
                </div>
                <Globe className="card-icon" />
              </div>
            )}

            {/* Total Courses */}
            <div
              className="dashboard-card clickable"
              onClick={() => this.props.history.push(`${process.env.PUBLIC_URL}/courses`)}
            >
              <div>
                <div className="card-label">Total Courses</div>
                <div className="card-count">
                  <CountUp className="counter" end={courseCount} />
                </div>
              </div>
              <Book className="card-icon" />
            </div>

            {/* Total Modules */}
            {loginUserData && loginUserData.role !== "corporate" && (
              <div
                className="dashboard-card clickable"
                onClick={() => this.props.history.push(`${process.env.PUBLIC_URL}/module`)}
              >
                <div>
                  <div className="card-label">Total Modules</div>
                  <div className="card-count">
                    <CountUp className="counter" end={moduleCount} />
                  </div>
                </div>
                <Package className="card-icon" />
              </div>
            )}

            {/* Total Sessions */}
            {loginUserData && loginUserData.role !== "corporate" && (
              <div
                className="dashboard-card clickable"
                onClick={() => this.props.history.push(`${process.env.PUBLIC_URL}/course-session`)}
              >
                <div>
                  <div className="card-label">Total Sessions</div>
                  <div className="card-count">
                    <CountUp className="counter" end={sessionCount} />
                  </div>
                </div>
                <Calendar className="card-icon" />
              </div>
            )}

            {/* Total Topics */}
            {loginUserData && loginUserData.role !== "corporate" && (
              <div
                className="dashboard-card clickable"
                onClick={() => this.props.history.push(`${process.env.PUBLIC_URL}/course-session-topic`)}
              >
                <div>
                  <div className="card-label">Total Topics</div>
                  <div className="card-count">
                    <CountUp className="counter" end={topicCount} />
                  </div>
                </div>
                <Bookmark className="card-icon" />
              </div>
            )}

            {/* Total Department */}
            <div
              className="dashboard-card clickable"
              onClick={() => this.props.history.push(`${process.env.PUBLIC_URL}/department`)}
            >
              <div>
                <div className="card-label">Total Department</div>
                <div className="card-count">
                  <CountUp className="counter" end={departmentsCount} />
                </div>
              </div>
              <Briefcase className="card-icon" />
            </div>

            {/* Corporate Specific Seat Stats */}
            {loginUserData && loginUserData.role === "corporate" && (
              <>
                {/* Allocated Seats */}
                <div className="dashboard-card">
                  <div>
                    <div className="card-label">Allocated Seats</div>
                    <div className="card-count">
                      <CountUp className="counter" end={totalMaxUsers} />
                    </div>
                  </div>
                  <UserPlus className="card-icon" />
                </div>

                {/* Used Seats */}
                <div className="dashboard-card">
                  <div>
                    <div className="card-label">Used Seats</div>
                    <div className="card-count">
                      <CountUp className="counter" end={totalAssignCount} />
                    </div>
                  </div>
                  <UserCheck className="card-icon" />
                </div>

                {/* Available Seats */}
                <div className="dashboard-card">
                  <div>
                    <div className="card-label">Available Seats</div>
                    <div className="card-count">
                      <CountUp className="counter" end={availableSeats} />
                    </div>
                  </div>
                  <Activity className="card-icon" />
                </div>
              </>
            )}
          </div>
        </div>
      </Fragment>
    );
  }
}

const mapStateToProps = (state) => ({
  authToken: state.auth.authToken,
  loginUserData: state.auth.loginUserData,
});

const mapDispatchToProps = (dispatch) => {
  return {
    setLoginFlag: (flag) => {
      dispatch({
        type: "SET_LOGIN_FLAG",
        flag: flag,
      });
    },
    setUserData: (userData) => {
      dispatch({
        type: "SET_USER_DATA",
        userData: userData,
      });
    },
    setUserToken: (authToken) => {
      dispatch({
        type: "SET_USER_AUTHTOKEN",
        authToken: authToken,
      });
    },
    setRouteName: (routeName) => {
      dispatch({
        type: "SET_ROUTE_NAME",
        routeName: routeName,
      });
    },
  };
};

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(withRouter(Default));
